export const SCHEMA_NAME = "WarrantCharges";

export const FIELDS = {
  WARRANT_CHARGE_ID: "warrantChargeID",
  WARRANT_ID: "warrantID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  CHARGE: "charge",
  CHARGE_NUMBER: "chargeNumber",
  OFFENSE_CODE: "offenseCode",
  CHARGE_LEVEL_ID: "chargeLevelID",
  CHARGE_COUNT: "chargeCount",
  CHARGE_MODIFIER_ID: "chargeModifierID",
  ORDINANCE: "ordinance",
  ADDITIONAL_CHARGE_INFO: "additionalChargeInfo",
  CONTROLLING_CHARGE: "controllingCharge",
  ORIGINAL_CHARGE: "originalCharge",
  ORIGINAL_OFFENSE_CODE: "originalOffenseCode",
  CHECK_BANK: "checkBank",
  CHECK_NUMBER: "checkNumber",
  CHECK_AMOUNT: "checkAmount",
  CHECK_PAYABLE_TO: "checkPayableTo",
  CHECK_RETURN_REASON: "checkReturnReason",
  CREATOR_STAFF_ID: "creatorStaffID",
  SEALED: "sealed",
  OCA: "oca",
  IMPORTED_CODE_SECTION: "importedCodeSection",
  IMPORTED_STATUTE_TITLE: "importedStatuteTitle",
  COMMENTS: "comments",
};
